import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/campus-2/campus-4.jpeg";

import pic1 from "../../Images/campus-2/campus-1.jpeg";
import pic2 from "../../Images/campus-2/campus-2.jpeg";
import pic3 from "../../Images/campus-2/campus-3.jpeg";
import pic4 from "../../Images/campus-2/campus-4.jpeg";
import pic5 from "../../Images/campus-2/campus-5.jpeg";

import acdpic1 from "../../Images/campus-2/acad-1.JPG";
import acdpic2 from "../../Images/campus-2/acad-2.JPG";
import acdpic3 from "../../Images/campus-2/acad-3.JPG";
import acdpic4 from "../../Images/campus-2/acad-4.JPG";
import acdpic5 from "../../Images/campus-2/acad-5.JPG";
import acdpic6 from "../../Images/campus-2/acad-6.JPG";
import acdpic7 from "../../Images/campus-2/acad-7.JPG";
import acdpic8 from "../../Images/campus-2/acad-8.JPG";

const RaipurCampus = () => {
  return (
    <>
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Raipur Campus</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Raipur Campus
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <div class="text-center mb-5">
            <h2 class="section-title modern-title text-blue mt-3">
              Raipur Off-Campus of ISBM University
            </h2>
            <p class="section-subtitle mx-auto fw-semibold">
              Explore, Engage, and Embrace the Vibrant Spirit of Campus Life
            </p>
          </div>
          <div className="vc-paragraphs mx-auto">
            <p>
              ISBM University’s Raipur Off-Campus Facility is designed as a
              convenient, accessible, and student-supportive center within the
              city. Located at a strategic urban point with direct connectivity
              to NH-53, the facility ensures smooth and easy travel for
              students, faculty, and visitors from all major routes. This
              highway linkage makes daily commuting faster and far more
              efficient.
            </p>
            <p>
              The Raipur Off-Campus functions primarily as a student service and
              academic support hub. It includes organized teaching spaces for
              scheduled classes, counseling rooms, administrative desks, and
              meeting areas for academic coordination. The setup focuses on
              providing essential support without overextending into full-campus
              infrastructure.
            </p>
            <p>
              Its city location places students close to corporate areas, market
              zones, service sectors, and industry points. This proximity
              naturally boosts opportunities for internships, field visits,
              training sessions, and real-world professional exposure — all of
              which strengthen career readiness.
            </p>
            <p>
              Along with academic support, the center hosts small-scale events,
              orientation activities, student interactions, and guidance
              sessions, creating a productive and approachable learning
              environment.
            </p>
            <p>
              Overall, the Raipur Off-Campus of ISBM University blends urban
              convenience, NH-53 connectivity, and student-focused facilities to
              create a practical, well-connected, and growth-oriented academic
              experience.
            </p>
          </div>
        </div>
      </section>

      {/* Vibrant Campus  */}
      <section className="ptb-50 bg-blue">
        <div className="container-xxl">
          <h2 className="section-title-start modern-title mb-0">
            A Glimpse into Our
            <span className="main-header-content text-golden">
              {" "}
              Vibrant Campus{" "}
            </span>
            Where Learning Meets Lifestyle
          </h2>
          <h6 class="modern-subtitle text-golden">
            At ISBM University, we are committed to developing leaders who are
            not merely skilled professionals but also compassionate people with
            strong ethical values.
          </h6>
          <p>
            ISBM University is committed to encourage many ideas from diverse
            sources, creating a flower bed of entrepreneurship and start-ups. It
            also reflects the vision of ISBM University that wants to see
            thousands of youth opening their minds to new vistas and
            opportunities by using the power of knowledge, skills and incubation
            provided by ISBM&nbsp;University.
          </p>

          <nav>
            <div class="nav nav-underline" id="nav-tab" role="tablist">
              <button
                class="nav-link active"
                id="nav-campus-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-campus"
                type="button"
                role="tab"
                aria-controls="nav-campus"
                aria-selected="true"
              >
                Campus
              </button>
              <button
                class="nav-link"
                id="nav-academics-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-academics"
                type="button"
                role="tab"
                aria-controls="nav-academics"
                aria-selected="false"
              >
                Academics
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-campus"
              role="tabpanel"
              aria-labelledby="nav-campus-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic1} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic2} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={pic3} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={pic5} className="gallery-image" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={pic4} className="gallery-image" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div
              class="tab-pane fade"
              id="nav-academics"
              role="tabpanel"
              aria-labelledby="nav-academics-tab"
              tabindex="0"
            >
              <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                {/* Left side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic1} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={acdpic2}
                            alt="Kabaddi Team"
                            className="gallery-image"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic3} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Right side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={acdpic4} className="gallery-image" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* left side - 1 big image */}
                <Col lg={6} className="gallery-col">
                  <div className="collage-item large-item">
                    <div className="gallery-image-wrapper">
                      <img src={acdpic5} className="gallery-image" />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h3></h3>
                          <p></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Right side - 4 images in 2x2 grid */}
                <Col lg={6} className="gallery-col p-0">
                  <Row className="gallery-inner-row g-3">
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic6} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img
                            src={acdpic7}
                            alt="Kabaddi Team"
                            className="gallery-image"
                          />
                          <div className="image-overlay">
                            <div className="overlay-content"></div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} className="gallery-inner-col">
                      <div className="collage-item small-item">
                        <div className="gallery-image-wrapper">
                          <img src={acdpic8} className="gallery-image" />
                          <div className="image-overlay">
                            <div className="overlay-content">
                              <p></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <div class="text-center mb-5">
            <h2 class="section-title modern-title text-blue mt-3">
              Our Campus Facilities
            </h2>
            <p class="section-subtitle mx-auto fw-semibold">
              At ISBM University, we are committed to developing leaders who are
              not merely skilled professionals but also compassionate people
              with strong ethical values.
            </p>
          </div>
          <div class="row g-4">
            <div class="col-md-6 col-lg-4">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-building"></i>
                  </div>
                  <h4 class="card-title">Modern Infrastructure</h4>
                  <p class="card-text">
                    The campus is equipped with modern facilities, including
                    lecture halls, seminar rooms, and auditoriums designed for a
                    conducive learning environment.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-book"></i>
                  </div>
                  <h4 class="card-title">Well-Stocked Library</h4>
                  <p class="card-text">
                    A vast collection of books, journals, and digital resources
                    is available for students to support their academic journey.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-icons"></i>
                  </div>
                  <h4 class="card-title">Extracurricular Activities</h4>
                  <p class="card-text">
                    Clubs, cultural events, and seminars enhance students'
                    overall development beyond academics.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-briefcase"></i>
                  </div>
                  <h4 class="card-title">Placement Cell</h4>
                  <p class="card-text">
                    A dedicated team assists students with career counseling,
                    internships, and job placements.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-leaf"></i>
                  </div>
                  <h4 class="card-title">Green Campus</h4>
                  <p class="card-text">
                    Landscaped gardens and eco-friendly practices maintain a
                    sustainable environment on campus.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mx-auto">
              <div class="card h-100 shadow card-facilities">
                <div class="card-body text-center p-4">
                  <div class="card-icon">
                    <i class="ti ti-wheelchair"></i>
                  </div>
                  <h4 class="card-title">Accessibility</h4>
                  <p class="card-text">
                    The campus is designed to be fully accessible to all
                    students, including those with disabilities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default RaipurCampus;
